export default "__VITE_ASSET__Dl_gg8HK__"